export default {
  // authentication
  authentication: {
    login: () => '/api-rest-auth/login/',
    logout: () => '/api-rest-auth/logout/',
    passwordReset: (id, token) => `/api-rest-auth/password/reset/confirm/${id}/${token}/`,
  },
  // alerts
  alerts: {
    all: () => 'api/activityalerts/',
    get: (id) => `api/activityalerts/${id}/`,
  },
  // account
  account: (id = null) => {
    return {
      all: `/api/accounts/`,
      self: `/api/accounts/${id}/`,
      users: `/api/accounts/${id}/users/`,
      cardTemplates: `/api/accounts/${id}/cardtemplates/`,
      addCard: (cardID) => `/api/accounts/${id}/cardtemplates/${cardID}/new/`,
    }
  },
  // user
  user: (id = 0) => {
    return {
      self: `/api/users/${id}/`,
      notifications: `/api/users/${id}/notifications/`,
      passwordResetRequest: `/api/users/password-reset/`,
    }
  },
  // DIY
  diy: () => {
    return {
      employees: '/api/employees/',
    }
  },
  // cards
  cards: {
    store: () => '/api/cards/',
    getCard: (id) => `/api/cards/${id}/`,
    userCards: (id = 0) => `/api/cards/?user=${id}/`,
    accountCards: (id = 0) => `/api/cards/?account=${id}`,
    cardChecklists: (cardId) => `api/cards/${cardId}/checklists/`,
    cardChecklist: (cardId, checklistId) => `api/cards/${cardId}/checklists/${checklistId}/`,
    cardChecklistItems: (
      cardId,
      checklistId
    ) => `api/cards/${cardId}/checklists/${checklistId}/items/
    `,
    cardChecklistItem: (cardId, checklistId, itemId) =>
      `api/cards/${cardId}/checklists/${checklistId}/items/${itemId}/`,
    cardActivities: (cardId) => `api/cards/${cardId}/activities/`,
    cardActivity: (cardId, activityId) => `api/cards/${cardId}/activities/${activityId}/`,
  },
  // cards templates
  templates: {
    store: () => '/api/cardtemplates/',
    template: (id) => `/api/cardtemplates/${id}/`,
    templateEdit: (id) => `/api/cardtemplates/${id}/edit/`,
    templateTranslations: (id) => `/api/cardtemplates/${id}/translations/`,
    templateChecklist: (templateId, checklistId) =>
      `api/cardtemplates/${templateId}/checklists/${checklistId}/`,
    templateChecklists: (id) => `api/cardtemplates/${id}/checklists/`,
    templateChecklistItem: (cardId, checklistId, itemId) =>
      `api/cardtemplates/${cardId}/checklists/${checklistId}/items/${itemId}/`,
    templateChecklistItems: (templateId, checklistId) =>
      `api/cardtemplates/${templateId}/checklists/${checklistId}/items/`,
  },
  // categories
  categories: {
    store: () => `/api/cardcategories/`,
  },
}
